<template>

    <liquidity
        :liquidity-url="route('api.v1.financial.liquidity.index')"
    ></liquidity>

</template>

<script>

    import Liquidity from "../../components/Business/Liquidity";

    export default {

        components: {
            Liquidity,
        },

        metaInfo: {
            title:'Liquidity',
        },

        name:'FinancialLiquidity',

    }

</script>
